export default __webpack_public_path__ + "static/media/Mask Group 1.4160a01e.png";